<template>
  <div class="py-2">
    <label v-if="label" class="block text-xss font-medium text-gray-700">{{label}}</label>
    <div v-if="description" class="text-gray-500 text-xs">
      {{description}}
    </div>
    <fieldset class="mt-4 ">    
      <div class="space-y-4">
        <div  v-for="item in data" :key="item.name" @click="update(item.value)" class="cursor-pointer relative flex items-start p-4 rounded-sm shadow-md" :class="(item.value == value) ? 'ring-2 ring-offset-2 ring-blue-600 text-gray-800 ' : 'ring-1 ring-offset-1 ring-blue-300 text-gray-500' ">
          <div class="relative items-start pt-0.5">            
            <div class="absolute top-0 w-8 h-8 rounded-full " @click="update(item.value)"></div>
            <input :id="item.value" type="radio" :checked="item.value === checked" class="focus:ring-blue-200 h-4 w-4 text-blue-400 border-blue-300" />
          </div>
          <div>
            <label :for="item.value" class="cursor-pointer ml-3 block text-xss font-medium ">
              {{ item.name }} 
              <div v-if="item.description" class="text-xs">{{item.description}}</div>
            </label>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>

import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'

export default {
  name: 'RadioList',
  props: {
    label: String,
    description: String,
    data: Array,    
    value: String,
  },
  components: {
    RadioGroup,
    RadioGroupDescription,
    RadioGroupLabel,
    RadioGroupOption,
  },
  data() {
    return {
       checked: '',
    }    
  },
  methods: {
    update(value){
      this.checked = value;
      this.$emit('update:modelValue', value);
    }
  },
  created() {
    if(this.value){
      this.update(this.value);      
    }
    else {
      this.update(this.data[0].value);
    }
  },
}
</script>